<template>
    <div :class="classes">
        <slot name="left"></slot>
        <slot name="right"></slot>
    </div>
</template>

<script>
export default {
    name: 'CoreTwoColumnsRow',

    props: {
        column: {
            type: Boolean,
            default: false,
        },

        showBorder: {
            type: Boolean,
            default: false,
        },

        padding: {
            type: Boolean,
            default: false,
        },

        error: {
            type: Boolean,
            default: false,
        },

        condensed: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        classes() {
            return {
                'core-two-columns-row': true,
                'core-two-columns-row--show-border': this.showBorder,
                'core-two-columns-row--add-padding': this.padding,
                'core-two-columns-row--error': this.error,
                'core-two-columns-row--condensed': this.condensed,
            }
        },
    },
}
</script>

<style scoped>
.core-two-columns-row {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 0;
    gap: 16px;
}

.core-two-columns-row.core-two-columns-row--show-border {
    border: 1px solid var(--color-neutral-500);
    border-radius: 8px;
    padding: 24px 16px;
}

.core-two-columns-row.core-two-columns-row--error {
    border: 1px solid var(--color-error);
}

.core-two-columns-row.core-two-columns-row--add-padding {
    padding: 26px 18px;
}

.core-two-columns-row.core-two-columns-row--condensed {
    padding: 1.5rem 2.4rem;
}
</style>
